import { backendClient } from '../../api/backend'
import {
  FETCH_SUBSCRIPTION_REQUEST,
  FETCH_SUBSCRIPTION_SUCCESS,
  FETCH_SUBSCRIPTION_FAILURE,
  CLEAR_SUBSCRIPTION,
} from '../reducers/subscriptionReducer'

export const fetchSubscription = () => async dispatch => {
  dispatch({ type: FETCH_SUBSCRIPTION_REQUEST })
  try {
    const data = await backendClient.getSubscription()
    dispatch({ type: FETCH_SUBSCRIPTION_SUCCESS, payload: data })
  } catch (error) {
    dispatch({ type: FETCH_SUBSCRIPTION_FAILURE, payload: error?.message || 'Failed to load subscription' })
  }
}

export const clearSubscription = () => ({ type: CLEAR_SUBSCRIPTION })
